export default __webpack_public_path__ + "static/media/0080.cc4d3ab2.jpg";